module.exports = __webpack_public_path__ + "images/scrooge-mcdick-eac22b226ccf1b409a0db7ead2298e28.png";